import { CountryConfigNames } from '../../../contexts/country-config-context/country-config-enums';
import { useCountryConfig } from '../../../hooks/use-country-config';
import { buildAmountSummary } from '../../../fulfillment-plans/amount-summary/helper';
import { useEntitiesFulfillmentPlan } from '../../../hooks/entities/selectors/fulfillment-plans';

export const useGetFulfillmentPlanAmountSummary = (fulfillmentPlanId) => {
  const { amountSummary = {} } = useEntitiesFulfillmentPlan(fulfillmentPlanId);

  const [isTaxesIncludedInOrdersTotal] = useCountryConfig(CountryConfigNames.TaxesIncludedInOrdersTotal);

  return buildAmountSummary(
    amountSummary?.shipping,
    amountSummary?.tax,
    amountSummary?.totalPaid,
    amountSummary?.total,
    isTaxesIncludedInOrdersTotal,
  );
};
